const REDIRECT_URL = 'https://altgraaf.onelink.me/FCKT/t7s8cpky';

export { REDIRECT_URL };
